import {
  NEWSLETTER_GET_LIST,
  NEWSLETTER_REQUEST,
  NEWSLETTER_SUCCESS,
  NEWSLETTER_FAILURE
} from '@/store/types'
import axios from '@/store/axios'

const state = {
  newsletters: null,
  isLoading: false,
  error: null,
  meta: {}
}

const getters = {
  isNewsletterLoading: (state) => state.isLoading,
  getNewsletters: (state) => state.newsletters,
  getNewsletterTotalCount: (state) =>
    state.meta.totalCount || (state.newsletters ? state.newsletters.length : 0)
}

const actions = {
  [NEWSLETTER_GET_LIST]: (
    { commit },
    { search, page, pageRow, newsletterSeq }
  ) => {
    return new Promise((resolve, reject) => {
      commit(NEWSLETTER_REQUEST)

      axios
        .get(`customer/newsletter/list`, {
          params: {
            search,
            pageNo: page,
            pageRow,
            newsletterSeq
          }
        })
        .then((resp) => {
          commit(NEWSLETTER_SUCCESS, {
            newsletters: resp.data.result?.newsletterList || [],
            meta: resp.data.page
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(NEWSLETTER_FAILURE, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [NEWSLETTER_REQUEST]: (state) => {
    state.isLoading = true
  },
  [NEWSLETTER_SUCCESS]: (state, { newsletters, meta }) => {
    state.isLoading = false

    if (newsletters) state.newsletters = newsletters
    if (meta) state.meta = meta
  },
  [NEWSLETTER_FAILURE]: (state, err) => {
    state.isLoading = false
    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
